module.exports = __webpack_public_path__ + "static/img/IMG_20240416_132627.3fbdf09c.jpg";